import { Button, Card, CardContent, H5, H6 } from "@sellar-io/components";
import React from "react";
import { useNavigate } from "react-router";
import { Alert } from "../../../../../components/alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";
import {
  Listbox,
  ListboxInputButton,
} from "../../../../../components/listbox/Listbox";
import { Toast } from "../../../../../components/toast/Toast";
import { useToast } from "../../../../../components/toast/useToast.shared";
import { CUSTOMERS, ORDER_BUYER } from "../../../../../constants/routes";
import { useStorefrontLinkCreate } from "../../../../../hooks/api/v2/storefrontLink/useStorefrontLinkCreate";
import { useStorefrontLinkList } from "../../../../../hooks/api/v2/storefrontLink/useStorefrontLinkList";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";

export const StorefrontShareContent = () => {
  const { business } = useSellarCurrentBusiness();
  if (!business?.Supplier) throw new Error("Only suppliers can view");
  const navigate = useNavigate();
  const storefrontLinkCreateMutation = useStorefrontLinkCreate();
  const storefrontLinkQuery = useStorefrontLinkList({
    query: [],
  });
  const storefrontLink = storefrontLinkQuery.data?.pages[0]?.[0];
  const url = `${import.meta.env.VITE_URL}${ORDER_BUYER.href({
    supplierIdOrUrlId: business.Supplier.urlId,
  })}`;
  const { toast } = useToast();

  const copyLink = (params?: string) => {
    toast({
      placement: "bottom",
      render: () => <Toast icon={"LINK"}>Link copied!</Toast>,
    });
    return navigator.clipboard.writeText(`${url}${params ? params : ""}`);
  };
  const onSubmit = () => {
    if (storefrontLink) {
      return copyLink(`?storefrontLink=${storefrontLink.password}`);
    }

    return storefrontLinkCreateMutation.mutate(
      {
        type: "default",
        PriceTierId: null,
        SupplierRetailerConnectionId: null,
      },
      {
        onSuccess: (response) =>
          copyLink(`?storefrontLink=${response.password}`),
      },
    );
  };
  return (
    <div className={"m-auto flex max-w-[900px] flex-col gap-4 p-4"}>
      <div className="grid grid-cols-3 gap-8">
        <div className="col-span-1">
          <div className="flex flex-col">
            <H5>Share your trade store link</H5>
            <H6>
              Bring customers to your trade store and allow them to order for
              themselves
            </H6>
          </div>
        </div>
        <div className="col-span-2">
          <Card className="bg-white">
            <CardContent className={"p-4"}>
              <div className="flex flex-col gap-4">
                <div className="">
                  <InputLabel>Public URL</InputLabel>
                  <InputContainer>
                    <InputText
                      required={false}
                      disabled={true}
                      value={`${url}${
                        storefrontLink
                          ? `?storefrontLink=${storefrontLink.password}`
                          : ""
                      }`}
                    />
                    <Listbox value={""} onChange={() => {}}>
                      <ListboxInputButton
                        icon={"CONTENT_COPY"}
                        className={"w-50"}
                        showChildren={true}
                        compact={true}
                        loading={storefrontLinkCreateMutation.isPending}
                        onClick={onSubmit}
                      >
                        Copy
                      </ListboxInputButton>
                    </Listbox>
                  </InputContainer>
                </div>
                <Alert
                  title={"Looking to send a link to a specific customer?"}
                  message={
                    "Find them on Sellar or set them up in your customer list. Give them instant access to your trade store with their usual pricing and terms."
                  }
                  type={"information"}
                >
                  <Button
                    color={"tertiary"}
                    className={"border-blue-300 bg-blue-100 text-blue-800"}
                    onClick={() => navigate(CUSTOMERS)}
                  >
                    Search for customers
                  </Button>
                </Alert>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};
